// on document ready (turbo-style)
document.addEventListener("turbo:load", function () {
  $('.load-later').each(function () {
    $(this).load($(this).data('href'))
  });

  $('.ui.checkbox').checkbox();
  $('select.dropdown').dropdown({ placeholder: false, fullTextSearch: "exact", ignoreDiacritics: true });
  $('div.dropdown').dropdown({ fullTextSearch: "exact" });

  $('.negative.basic.button').mouseover(function () { $(this).removeClass('basic'); })
    .mouseout(function () { $(this).addClass('basic'); });

  // see websites_controller#search for the server-side implementation
  $.fn.search.settings.templates = {
    website: function (response) {
      if (response.success && response.results) {
        return response.results.map((ws) => {
          return `<a class="result ${ws.classList}">` + ws.name +
            (ws.siteType ? ` (${ws.siteType})` : '') +
            (ws.description ? `<br><small>${ws.description}</small>` : '') + `</a>`;
        }).join("\n");
      }
    },
    message: function (message, type) {
      return `<div class="message message-${type}">${message}</div>`;
    }
  };


  /*
   * jump to website in top nav
   */

  const isMac = navigator.userAgent.indexOf('Mac') !== -1;
  document.querySelectorAll('.website-search input').forEach(input => {
    if (!isMac) input.placeholder = input.placeholder.replace('⌘', 'Ctrl-');
  });

  $('.website-search')
    .search({
      type: 'website',
      apiSettings: { url: "/websites/search?q={query}" },
      maxResults: 100, // generally limited by websites#search instead of this
      selectFirstResult: true,
      showNoResults: true,
      onSelect: function (result, response) {
        // $('.website-search').dropdown('hide results');
        Turbo.visit(result.value);
      },
    });

  document.querySelectorAll('.website-search input.prompt').forEach(searchInput => {
    searchInput.addEventListener('input', () => {
      const re = /https?:\/\/(?:www\.)?([^\/\s\:]+).*?$/;
      if (searchInput.value.match(re)) searchInput.value = searchInput.value.replace(re, '$1');
    });
  });
});

// Register once, rather than adding another shortcut handler on every Turbo visit.
document.addEventListener('keydown', event => {
  const isMac = navigator.userAgent.indexOf('Mac') !== -1;
  if (event.key.toLowerCase() !== 'k' || !(isMac ? event.metaKey : event.ctrlKey)) return;
  const input = Array.from(document.querySelectorAll('.website-search input'))
    .find(candidate => candidate.getClientRects().length > 0);
  if (input) {
    event.preventDefault();
    input.focus();
  }
});
